// --------------------------------------------------------------------------
// #TBC - Reset chart container
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function () {

	var $chartContainer = $('body').find('[data-binding="chart-container"]');
	var $chartWrapper = $('[data-bind="charting-charts-wrapper"]');

	$chartWrapper.css({ height: 'auto' });
	$chartContainer.css({ position: 'static' });

	return true;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-reset-height.js
// module id = 101
// module chunks = 0